import { gql } from "@apollo/client";

export const GET_PACKAGE_ORDERS = gql`
  query getPackageOrders($where: package_order_bool_exp) {
    package_order(where: $where, order_by: { created_at: desc }) {
      id
      quantity
      system_offer
      order_package {
        id
        chinese_name
        name
      }
      selling_price
      status
      payment_slip
    }
  }
`;

export const GET_DELIVERABLE_ORDERS = gql`
  query getDeliverableOrders($where: orders_with_delivery_bool_exp) {
    orders_with_delivery(where: $where, order_by: { created_at: desc }) {
      order_id
      quantity
      type
      status
      created_at
      type
    }
  }
`;
